<template>
  <div class="content">
    <a-spin :spinning="loading" tip="加载中...">
    <Layout>
      <template #title> 指数中心 </template>
      <template #filter>
        
        <a-select v-show="tag == 1 || tag == 2" v-model="year" style="width: 120px">
          <a-select-option
            v-for="item in yearList"
            :key="item.years"
            :value="item.years"
            >{{ item.years }}</a-select-option
          >
        </a-select>
        <a-tree-select
          v-show="tag == 3"
          v-model="regionCode"
          :tree-data="regionList"
          style="width:150px"
          :dropdownStyle="{ height:'240px'}"
        ></a-tree-select>
      </template>

      <template #route>
        <a :class="{active: cubeId == 91}" @click="cubeId = 91; tag = 1;year = yearList[0].years;title='边疆治理'">边疆治理指数</a>
        <a :class="{active: cubeId == 1}" @click="cubeId = 1; tag = 1;year = yearList[0].years;title='包容性'">包容性发展指数</a>
        <a :class="{active: cubeId == 3}" @click="cubeId = 3; tag = 1;year = yearList[0].years;title='绿色化'">绿色发展指数</a>
        <a :class="{active: cubeId == 2}" @click="cubeId = 2; tag = 1;year = yearList[0].years;title='高质量'">高质量发展指数</a>
      </template>
    </Layout>
    <div class="inclusion">
      <a-row style="display: flex;">
        <a-col class="col-l fl">
          <div class="item" :class="{ active: tag == 1 }" @click="tag = 1,year = yearList[0].years">
            <span class="iconfont2 icon-jurassic_pie-chart"></span>指数分布
          </div>
          <div class="item" :class="{ active: tag == 2 }" @click="tag = 2,year = yearList[0].years">
            <span class="iconfont2 icon-suanfasuanzicopy"></span>指数构成
          </div>
          <div class="item" :class="{ active: tag == 3 }" @click="tag = 3,year = yearList[0].years">
            <span class="iconfont2 icon-qushi"></span>指数趋势
          </div>
          <div class="item" :class="{ active: tag == 4 }" @click="tag = 4,year = yearList[0].years">
            <span class="iconfont2 icon-wj-fswj"></span>重心转移
          </div>
        </a-col>
        <a-col class="col-r fr">
          <keep-alive>
            <Scatter v-if="tag == 1" :tag="tag" :year="year" :cubeId="cubeId" :title="title" @setLoading="setLoading"></Scatter>
            <Mackup v-if="tag == 2" :tag="tag" :cubeId="cubeId" :year="year" :title="title"></Mackup>
            <Trend v-if="tag == 3" :tag="tag" :cubeId="cubeId" :regionCode="regionCode" :title="title"></Trend>
            <Gravity v-if="tag == 4" :tag="tag" :cubeId="cubeId" :title="title"></Gravity>
          </keep-alive>
        </a-col>
      </a-row>
    </div></a-spin>
  </div>
</template>

<script>
import Layout from "../components/layout.vue";
import Scatter from "./inclusion/scatter.vue";
import Trend from "./inclusion/trend.vue";
import Mackup from "./inclusion/mackup.vue";
import Gravity from "./inclusion/gravity.vue";
export default {
  components: { Layout, Scatter, Trend, Mackup, Gravity },
  data() {
    return {
      loading:false,
      tag: 1,
      year: null,
      yearList: [],
      cubeId:91,
      regionList:[],
      regionCode:null,
      title:'边疆治理',
    };
  },

  mounted() {
    this.getYears();
    // this.getRegion();
  },

  methods: {
    getYears() {
      this.$http.getYears({ cubeId: 1 }).then((res) => {
        if (res.success) {
          this.yearList = res.list;
          this.year = res.list[0].years;
        }
      });
    },
    getRegion(){
      this.$http.getAllRegion({cubeId:this.cubeId}).then((res)=>{
        if(res.success){
          this.regionList = res.regionList.map(item=>{
            item.cityList.forEach(i => {
              i.title = i.name,
              i.value = i.code
              i.key = i.code
            });
            return {
              title : item.name,
              value : item.code,
              key : item.code,
              disabled:true,
              children : item.cityList
            }
          })
          this.regionCode = this.regionList[0].children[0].value 
        }
      })
    },
    setLoading(e) {
      this.loading=e
    }
  },
  watch:{
    tag(val){
      if(val == 3){
        this.getRegion();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";
</style>

